import { DELETEPROFILEPIC, DELETEPROFILEPIC_ERROR, DELETEPROFILEPIC_HIDE_ERROR, DELETEPROFILEPIC_START_LOADER, DELETEPROFILEPIC_STOP_LOADER } from "../interface/IDeleteProfilePic";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const DeleteProfilePicReducer = (state = initState, action) => {
    switch (action.type) {
        case DELETEPROFILEPIC:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case DELETEPROFILEPIC_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case DELETEPROFILEPIC_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case DELETEPROFILEPIC_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case DELETEPROFILEPIC_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default DeleteProfilePicReducer;
